import { render, staticRenderFns } from "./BlogFullList.vue?vue&type=template&id=752a5cc6&scoped=true"
import script from "./BlogFullList.vue?vue&type=script&lang=js"
export * from "./BlogFullList.vue?vue&type=script&lang=js"
import style0 from "./BlogFullList.vue?vue&type=style&index=0&id=752a5cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.aspect_rules_js/vue-loader@15.11.1_219357517/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a5cc6",
  null
  
)

export default component.exports